import image from '../../assets/abstract.jpg';

export default function MobileFeatureCard() {
    return (
        <div className="pb-3">
            <div className="card w-100">
                <img src={image} className="card-img-top" alt="..."/>
                <div className="row pt-2">
                    <h5>Exhibition 1</h5>
                    <p>Gallery name | date - date</p>
                </div>
            </div>
        </div>
    )
}